import { render, staticRenderFns } from "./icon-circle.vue?vue&type=template&id=45bce136&scoped=true&"
import script from "./icon-circle.vue?vue&type=script&lang=js&"
export * from "./icon-circle.vue?vue&type=script&lang=js&"
import style0 from "./icon-circle.vue?vue&type=style&index=0&id=45bce136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bce136",
  null
  
)

export default component.exports